import type { Opportunity } from 'types/savings';
import { createDialogWithIdStore } from '../createDialogWithIdStore';

export const useOpportunityTeamDialog = createDialogWithIdStore<Opportunity[]>();
